import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './copy.scss';

class Copy extends Component {
  static propTypes = {
    color: PropTypes.string,
    type: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    bold: PropTypes.bool,
  };

  static defaultProps = {
    color: '#fff',
    type: 'intro',
    bold: false,
  };

  getClassNames() {
    const { className, color, type, bold } = this.props;

    return classnames(styles.copy, className, styles[color], styles[type], bold && styles.bold);
  }
  
  render() {
    const { children } = this.props;

    return (
      <div className={this.getClassNames()}>
        {children}
      </div>
    );
  }
}

export { Copy };



// WEBPACK FOOTER //
// ./src/elements/copy/copy.js